import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BankData } from './bankData';

const routes: Routes = [
  {
    path: 'bank',
    component: BankData,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BankDataRoutingModule {}
